import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { fetchPopupEvent } from "../lib/api";

export default function AnnouncementBanner() {
  const [event, setEvent] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetchPopupEvent().then((e) => setEvent(e || null)).catch(() => {});
    setDismissed(sessionStorage.getItem("hmf_banner_dismissed") === "1");
  }, []);

  if (!event || dismissed) return null;

  return (
    <div data-testid="announcement-banner" className="relative bg-brand-teal text-brand-cream">
      <div className="container-editorial flex items-center justify-between gap-3 py-2.5 text-[13px] sm:text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="w-4 h-4 text-brand-peach shrink-0" />
          <span className="truncate">
            <span className="font-semibold">{event.title}</span>
            {(event.date_label || event.time_label) && (
              <span className="hidden sm:inline">
                {" · "}{[event.date_label, event.time_label].filter(Boolean).join(" · ")}
              </span>
            )}
          </span>
        </div>
        <div className="flex items-center gap-4">
          {event.rsvp_url && (
            <a
              href={event.rsvp_url}
              target="_blank"
              rel="noreferrer"
              data-testid="banner-rsvp-btn"
              className="underline underline-offset-4 hover:text-brand-peach transition-colors font-medium"
            >
              RSVP
            </a>
          )}
          <button
            aria-label="Dismiss"
            data-testid="banner-dismiss"
            onClick={() => {
              sessionStorage.setItem("hmf_banner_dismissed", "1");
              setDismissed(true);
            }}
            className="p-1 rounded-full hover:bg-white/10"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
